function normalizeTeamGoalsFromScore(score = [0, 0]) {
  return Array.isArray(score) && score.length === 2
    ? score.map((value) => {
        const normalized = Number(value);
        return Number.isFinite(normalized) && normalized >= 0 ? normalized : 0;
      })
    : [0, 0];
}

function normalizeEmail(value) {
  return String(value || '').trim().toLowerCase();
}

function sortMatchEvents(matchEvents = []) {
  return [...(Array.isArray(matchEvents) ? matchEvents : [])].sort((left, right) => {
    if ((left?.minute || 0) !== (right?.minute || 0)) {
      return (left?.minute || 0) - (right?.minute || 0);
    }

    return (left?.sortIndex || 0) - (right?.sortIndex || 0);
  });
}

function buildLatestSwitchTeamIndexByEmail(matchEvents = []) {
  const latestSwitchByEmail = new Map();

  sortMatchEvents(matchEvents).forEach((event) => {
    if (event?.type !== 'team_switch') return;

    const email = normalizeEmail(event?.playerEmail);
    const teamIndex = Number(event?.toTeamIndex);
    if (!email || (teamIndex !== 0 && teamIndex !== 1)) {
      return;
    }

    latestSwitchByEmail.set(email, teamIndex);
  });

  return latestSwitchByEmail;
}

function deriveTeamGoalsFromMatchEvents(matchEvents = []) {
  const teamGoals = [0, 0];
  let hasGoalEvent = false;

  (Array.isArray(matchEvents) ? matchEvents : []).forEach((event) => {
    if (event?.type !== 'goal') return;

    const teamIndex = Number(event?.teamIndex);
    if (teamIndex !== 0 && teamIndex !== 1) return;

    teamGoals[teamIndex] += 1;
    hasGoalEvent = true;
  });

  return hasGoalEvent ? teamGoals : null;
}

export function buildFinishGamePayload({
  game,
  goals = {},
  assists = {},
  attendance = {},
  cardCounts = {},
  matchEvents = [],
  score = [0, 0],
}) {
  const stats = [];
  const normalizedMatchEvents = Array.isArray(matchEvents) ? matchEvents : [];
  const latestSwitchTeamIndexByEmail = buildLatestSwitchTeamIndexByEmail(normalizedMatchEvents);

  game?.teams?.forEach((team, teamIndex) => {
    team.forEach((player) => {
      if (!player?.email) return;

      const email = player.email;
      const normalizedEmail = normalizeEmail(email);
      stats.push({
        email,
        teamIndex: latestSwitchTeamIndexByEmail.has(normalizedEmail)
          ? latestSwitchTeamIndexByEmail.get(normalizedEmail)
          : teamIndex,
        goals: goals[email] || 0,
        assists: assists[email] || 0,
        yellow_cards: cardCounts?.[email]?.yellow || 0,
        red_cards: cardCounts?.[email]?.red || 0,
        attendance: attendance[email] || 'absent',
      });
    });
  });

  const teamGoals =
    deriveTeamGoalsFromMatchEvents(normalizedMatchEvents) ||
    normalizeTeamGoalsFromScore(score);

  return {
    status: 'finished',
    teamGoals,
    matchEvents: normalizedMatchEvents,
    stats,
  };
}
